var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 368.2 114",
    style: {
      enableBackground: "new 0 0 368.2 114"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0033A1;}\n\t.st1{fill:#FF671D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.9,20.4h12.4v72.3h-14.1V49.8l-16.6,31h-10.3l-16.6-30.6v42.5h-14.1V20.4h12.6l23.3,44.2L194.9,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M231,85.8c-5.3-5.2-8-12.9-8-22.9V20.4h15.7v43.2c0,5.7,1.3,10.1,3.9,13.1c2.6,3,6.4,4.5,11.4,4.5 c5,0,8.8-1.5,11.5-4.6c2.7-3,4-7.4,4-13.1V20.4h15.7v42.5c0,10-2.7,17.6-8,22.9c-5.3,5.3-13.1,7.9-23.2,7.9 C244.1,93.6,236.3,91,231,85.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.4,92.7l-6.9-16h-33.6l-6.9,16h-16.1l33.2-72.3h12.8l33.2,72.3H352.4z M317.1,64.6h23.2l-11.6-27.1 L317.1,64.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.6,0L57,16.2L44.5,0l-24,9.9C22.6,12.6,56,55.8,57,57L93.5,9.9L69.6,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.6,0L57,16.2L44.5,0l-24,9.9C22.6,12.6,56,55.8,57,57L93.5,9.9L69.6,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,44.5L16.2,57L0,69.5l9.9,24C12.6,91.4,55.8,58,57,57L9.9,20.5L0,44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.5,114L57,97.8L69.6,114l24-9.9C91.4,101.4,58,58.3,57,57l-36.5,47.1L44.5,114z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114,69.5L97.9,57L114,44.5l-9.9-24C101.5,22.6,58.3,56,57,57l47.1,36.5L114,69.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTransparent);
export default __webpack_public_path__ + "static/media/logo-transparent.6f3ac8bac42a0f13311017e49299bfb4.svg";
export { ForwardRef as ReactComponent };